import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Title from "Components/Title";
import { 
  Typography, 
  Box 
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  row: {
    lineHeight: "1.5em",
    height: "5.1em",
    cursor: "pointer",
  },
  loading: {
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    fontSize: "20px",
  },
  content: {
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
  },
  follow: {
    minWidth: 88,
    width: 96,
    whiteSpace: "nowrap",
    textAlign: "right",
  },
  count: {
    color: "#ee3333",
    whiteSpace: "nowrap",
  },
}));

export default function Contributors(props) {
  const classes = useStyles();

  const formatRpCount = (count) => {
    if (count >= 10000) {
      const wanCount = Math.floor((count / 10000) * 10) / 10;
      return `${wanCount}万`;
    }
    return `${count}`;
  };

  const contents = () => {
    if (!props.isApiReturn) {
      return [...Array(10)].map((row, index) => (
        <TableRow key={index} className={classes.row}>
          <TableCell>{index + 1}</TableCell>
          <TableCell>
            <span className={classes.loading}>Loading...</span>
          </TableCell>
        </TableRow>
      ));
    } else {
      if (props.content.length > 0) {
        return props.content.map((row, index) => (
          <TableRow
            key={index}
            className={classes.row}
            data-testid={`contributor-row-${index}`}
            onClick={() => props.handleClickRow(row.screen_name)}
            hover
          >
            <TableCell>{index + 1}</TableCell>
            <TableCell>
              <span className={classes.content}>{row.user_name}</span>
            </TableCell>
            <TableCell className={classes.follow} data-testid={`contributor-followers-${index}`}>
              <Box display="flex" flexDirection="column" alignItems="flex-end">
                  <Typography 
                    variant="caption" 
                    component="span" 
                    style={{ 
                      fontSize: '0.7rem', 
                      lineHeight: 1, 
                      color: '#666',
                      marginBottom: '2px'
                    }}
                  >
                    フォロワー
                  </Typography>
                  <Typography 
                    variant="body2" 
                    component="span" 
                    style={{ 
                      fontSize: '0.7rem', 
                      lineHeight: 1 
                    }}
                  >
                    {formatRpCount(row.followers_count).toLocaleString()}
                  </Typography>
                </Box>
            </TableCell>
            <TableCell className={classes.count}>{formatRpCount(row.count)}件</TableCell>
          </TableRow>
        ));
      } else {
        return [...Array(10)].map((row, index) => (
          <TableRow key={index} className={classes.row}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>
              <span className={classes.content}>-</span>
            </TableCell>
            <TableCell className={classes.count}>-</TableCell>
          </TableRow>
        ));
      }
    }
  };

  return (
    <React.Fragment>
      <Title>投稿者</Title>
      <Table size="small" data-testid="contributors-table">
        <TableBody>{contents()}</TableBody>
      </Table>
    </React.Fragment>
  );
}
